
import CloseIcon from '@/components/Icons/CloseIcon.vue';
import { FocusTrap } from 'focus-trap-vue';
import Vue from 'vue';


export default Vue.extend({
  name: 'AsModal',
  data: function(){
    return{
      isActive: true,
      returnFocusOnDeactivate: true
    }
  },
  components: {
    CloseIcon,
    FocusTrap: FocusTrap,
  },
  props: {
    title: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
    clickOutside(e: MouseEvent, eee: any) {
      if (e.target == this.$refs.background) this.close();
    },
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.clickOutside as any);
    }, 10);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside as any);
  },
});
